import { ReactElement } from 'react'

import Icon from '@ant-design/icons'

import { IconProps } from '../localTypes'

import TrendDownIconSvg from './TrendDownIconSvg'

const TrendDownIcon = (props: IconProps): ReactElement => {
    const { color, height = '1em', width = '1em' } = props
    return (
        <Icon
            component={() => (
                <TrendDownIconSvg color={color} height={height} width={width} />
            )}
            {...props}
        />
    )
}

export default TrendDownIcon
